import axios from 'axios'
// import * as config from './../settings'

export default {

    checkCode(code) {
        return axios.get(`${process.env.VUE_APP_API_URL}code/validate?code=${code}`)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    checkFormParticipation(data) {
        return axios.post(`${process.env.VUE_APP_API_URL}form/validate`, data)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    updateFormParticipation(data) {
        return axios.post(`${process.env.VUE_APP_API_URL}form/participate`, data)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    }
    /*
    checkCode(code) {
        let data = null;
        code = code.toLowerCase();

        if(code === 'aaaaaa') {
            data = {
                'type' : 'invalid',
                'message' : 'Code is Invalid'
            }
        } else if (code === 'bbbbbb') {
            data = {
                'type' : 'valid',
                'message' : 'Code valid',
                'codeObject' : {},
                'price' : 'C'
            }
        } else if (code === 'cccccc') {
            data = {
                'type' : 'used',
                'message' : 'Code already used'
            }
        } else if (code === 'dddddd') {
            data = {
                'type' : 'valid',
                'message' : 'Code valid',
                'codeObject' : {},
                'price' : 'D'
            }
        } else if (code === 'eeeeee') {
            data = {
                'type' : 'valid',
                'message' : 'Code valid',
                'codeObject' : {},
                'price' : 'F'
            }
        } else if(code === 'ffffff') {
            data = {
                'type' : 'valid',
                'message' : 'Code valid',
                'codeObject' : {},
                'price' : 'A'
            }
        } else {
            data = {
                'type' : 'invalid',
                'message' : 'Code is Invalid'
            }
        }

        return Promise.resolve(data);
    } */
}
